import FilterFooterActions from '@/components/ui/Button/FilterFooter';

export const DropdownFooter = ({
  onClear,
  onApply,
}: {
  onClear: () => void;
  onApply: () => void;
}) => (
  <FilterFooterActions
    onClear={onClear}
    onApply={onApply}
    size="footer"
    applyWeight="bold"
  />
);
